import Action, { ActionType } from '../Actions/ActionTypes'
import { Reducer } from 'redux'
import SeenState from '../State/SeenState'

const actionSeenShow = (oldState: SeenState, _action: Action): SeenState => {
    return { ...oldState, show : !oldState.show}
}

type Process = (oldState: SeenState, action: Action) => SeenState

export const SeenReducer: Reducer<SeenState, Action> = (state: SeenState = { show: false}, action: Action): SeenState => {

    let actionMap = new Map<ActionType, Process>()
    actionMap.set(ActionType.SEEN_SHOW, actionSeenShow)

    return actionMap.get(action.type)?.call(undefined, state, action) ?? state

}


